import { createSlice } from "@reduxjs/toolkit";
import { fetchGRNList } from "./thunk";

interface GRNState {
  list: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: GRNState = {
  list: [],
  rowCount: 0,
  loading: false,
  error: null,
};

const projectGRNSlice = createSlice({
  name: "projectGRN",
  initialState,
  reducers: {
    resetGRNState: () => initialState,
  },
  extraReducers: (builder) => {
    // ✅ GRN List
    builder
      .addCase(fetchGRNList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchGRNList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchGRNList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch GRN List";
      });
  },
});

export const { resetGRNState } = projectGRNSlice.actions;
export default projectGRNSlice.reducer;
